export default __webpack_public_path__ + "static/media/login-screen-1.32af2566.jpg";